import { gql } from "@stadium/services/apollo-client";

export const POPULATE_DRAFT_AUTOMATED_CATALOG = gql`
  mutation PopulateDraftAutomatedCatalog($input: PopulateDraftAutomatedCatalogInput!) {
    populateDraftAutomatedCatalog(input: $input) {
      errors
      paginatedProducts {
        total
        countryWiseProductCount
        globalProductCount
        totalColorOptions
        totalProductsCount
        products {
          id
          name
          slug
          availableGlobally
          availableCountries {
            iso
            name
          }
          brand {
            id
            name
          }
          images
          selectedColorOptions {
            id
            name
            presentation
          }
          selectedColorsWithTemplate {
            images
            optionValue {
              id
              name
              presentation
            }
          }
        }
      }
    }
  }
`;
